import axios from "axios";
import { toast } from "react-toastify";

//fisrt argument => positive requests
//second argument => negative requests
axios.interceptors.request.use(function (config) {
  const userData = JSON.parse(window.localStorage.getItem("userData"));

  if (userData) {
    config.headers.authorization = `Bearer ${userData.token}`;
  }

  return config;
});

axios.interceptors.response.use(

  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status >= 400 && error.response.status <= 499) {
      toast.error((error.response.data && error.response.data.error) || "Error de solicitud");
    } else if (!error.response) {
      toast.error("No se pudo conectar con el servidor.");
    }
    return Promise.reject(error);
  }
);

const methods = {
  get: "GET",
  post: "POST",
  put: "PUT",
  delete: "DELETE",
};

export default {
  methods,
  get: axios.get,
  post: axios.post,
  delete: axios.delete,
  put: axios.put,
};
